import { Component, inject } from '@angular/core';
import { NgComponentOutlet } from '@angular/common';
import { ModalService } from '../../../core/services/modal.service';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [NgComponentOutlet],
  templateUrl: './modal.component.html',
})
export class ModalComponent {
  readonly modalService = inject(ModalService);
}
